import styled from 'styled-components';

export default styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  font-family: 'Assistant';

  &.in-table {
    font-size: 1rem;
    width: 100%;
    padding: 6px;
    width: 100%;
    padding: 6px 7px 6px;
    border-radius: 4px;
    border-color: #cbcbcb;
    font-size: 1.1rem;
  }
`;
